/** Email yang mendapat akses panel admin (dipakai UI; otoritas tetap di server). */
export const ADMIN_EMAILS = ["arinotdev@gmail.com"];

export function isAdminEmail(email: string | null | undefined) {
  return Boolean(email && ADMIN_EMAILS.includes(email.toLowerCase()));
}
